import { render, staticRenderFns } from "./DniFieldBusiness.vue?vue&type=template&id=43ca5342&scoped=true&"
import script from "./DniFieldBusiness.vue?vue&type=script&lang=ts&"
export * from "./DniFieldBusiness.vue?vue&type=script&lang=ts&"
import style0 from "./DniFieldBusiness.vue?vue&type=style&index=0&id=43ca5342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ca5342",
  null
  
)

export default component.exports